import { memo } from "react";

function MentorAcademy() {
  return (
    <main className="container mt-5" aria-label="Mentor Academy">
      <div className="row">
        <h1>Mentor Academy</h1>
      </div>
    </main>
  );
}

MentorAcademy.displayName = "MentorAcademy";

export default memo(MentorAcademy);